import { LucideProps } from 'lucide-react'

const VerifiedCheck = (props: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    {...props}
  >
    <g id="Verified">
      <g clipPath="url(#clip0_6287_2789)">
        <g id="Group">
          <path
            id="Vector"
            d="M22.7639 13.7697C23.3611 13.0869 23.3611 12.0676 22.7639 11.3848L21.7928 10.2743C21.4661 9.90084 21.307 9.40972 21.3525 8.91566L21.4875 7.45091C21.5708 6.54613 20.971 5.71958 20.085 5.51832L18.6579 5.19417C18.1719 5.08378 17.7529 4.77805 17.4995 4.34896L16.7505 3.08092C16.2872 2.29645 15.3133 1.97819 14.4762 2.33768L13.1357 2.91328C12.6794 3.10924 12.1626 3.10924 11.7063 2.91328L10.3638 2.33681C9.52749 1.9777 8.55459 2.29489 8.09067 3.07791L7.34411 4.33798C7.08968 4.76742 6.66932 5.07283 6.18228 5.18211L4.76165 5.50086C3.87348 5.70015 3.27115 6.52761 3.35444 7.43405L3.48983 8.90745C3.53512 9.40026 3.3768 9.89014 3.05167 10.2632L2.07405 11.3851C1.47889 12.0681 1.47979 13.0857 2.07616 13.7676L3.04938 14.8804C3.37591 15.2538 3.53505 15.7447 3.48966 16.2386L3.35405 17.7143C3.27093 18.619 3.87073 19.4453 4.75661 19.6465L6.1855 19.971C6.67063 20.0812 7.08908 20.3861 7.34266 20.8141L8.08864 22.0732C8.55343 22.8577 9.52891 23.1744 10.3659 22.8125L11.7046 22.2337C12.1619 22.036 12.6804 22.0354 13.1381 22.232L14.4782 22.8074C15.3145 23.1665 16.2874 22.8493 16.7513 22.0663L17.4993 20.8038C17.7529 20.3758 18.1713 20.0709 18.6565 19.9607L20.085 19.6362C20.971 19.435 21.5708 18.6084 21.4875 17.7036L21.3525 16.2389C21.307 15.7448 21.4661 15.2537 21.7928 14.8802L22.7639 13.7697ZM10.6272 17.2791C10.5261 17.3805 10.3619 17.3805 10.2608 17.2791L6.6932 13.7022C6.59237 13.6011 6.59248 13.4374 6.69344 13.3365L7.85924 12.1706C7.96045 12.0694 8.1246 12.0696 8.22559 12.171L10.2607 14.2149C10.3618 14.3165 10.5262 14.3165 10.6274 14.215L16.3162 8.50671C16.4172 8.40536 16.5813 8.40522 16.6825 8.5064L17.8484 9.6723C17.9493 9.77325 17.9494 9.9369 17.8486 10.038L10.6272 17.2791Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6287_2789">
        <rect
          y="0.15625"
          width="24.8418"
          height="24.8418"
          rx="1.29384"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
)

export default VerifiedCheck
